<template>

    <div id="visorPlanesRecarga">
        <loading v-if="isLoading" />
        <div v-else class="slider-container">
            <div class="slider-wrapper" :style="{ transform: `translateX(-${currentSlide * slideWidth}%)` }">
                <div class="slide" v-for="(slide, index) in slides" :key="index">
                    <div class="slide-content">
                        <img :src="slide.image" :alt="slide.title" class="w-100" />
                        <div class="p-3">
                            <h3>{{ slide.title }}</h3>
                            <p>{{ slide.description }}</p>
                            <span class="price">{{ slide.price }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <button class="prev" @click="prevSlide" :disabled="currentSlide === 0">
                 <i class="fa fa-chevron-left fa-fw"></i>
            </button>
            <button class="next" @click="nextSlide" :disabled="currentSlide >= maxSlide">
                <i class="fa fa-chevron-right fa-fw"></i>
            </button>
        </div>
    </div>

</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import stripeObj from '@/stripe/stripeHandler';
export default {
    name: 'VisorPlanesRecarga',
    data() {
        return {
            isLoading: false,
            currentSlide: 0,
            slideWidth: 100,
            slides: [
                // {
                //     title: 'Plan Básico',
                //     description: 'Descripción del plan básico de recarga',
                //     price: '$9.99',
                //     image: 'https://placehold.co/400x300/FF9800/ffffff?text=Plan+Basico'
                // },
            ]
        }
    },
    mounted() {
        this.loadUp();
    },
    computed: {
        maxSlide() {
            return this.slides.length - 1
        }
    },
    methods: {
        async loadUp(){
            this.isLoading = true;
            try {
                const response = await axios.get('index.php?r=claveverde/ofertas/getrecargas')
                if(response.status){
                    stripeObj.setStripePublicKey(response.stripePublicKey);
                    this.slides = _.map(response.data, (plan) => {
                        const item = {
                            title: plan.planName,
                            description: plan.descr,
                            price: `$${plan.precio}`,
                            price_nominal: `$${plan.precio_nominal}`,
                            image: this.$options.filters.imageIdToURL(plan.imagenes_id, {w: 512, h: 600}),
                            fullOffer: plan
                        };
                        return item;
                    })
                    this.$emit('input', this.slides[this.currentSlide].fullOffer);
                }

            } catch (error) {
                console.error('Error loading plans:', error)
                this.slides = [];
            } finally {
                this.isLoading = false;
            }
        },
        nextSlide() {
            if (this.currentSlide < this.maxSlide) {
                this.currentSlide++
            }
            this.$emit('input', this.slides[this.currentSlide].fullOffer);
        },
        prevSlide() {
            if (this.currentSlide > 0) {
                this.currentSlide--
            }
            this.$emit('input', this.slides[this.currentSlide].fullOffer);
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/app.scss';

#visorPlanesRecarga {

    .price {
        font-size: 1.5em;
        font-weight: bold;
        margin-top: 10px;
    }

    .slider-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
    }

    .slider-wrapper {
        display: flex;
        transition: transform 0.3s ease-in-out;
    }

    .slide {
        min-width: 100%;
        box-sizing: border-box;
    }

    .slide-content {
        background: #f5f5f5;
        // padding: 30px;
        overflow: hidden;
        border-radius: 8px;
        text-align: center;

        h3 {
            margin-bottom: 15px;
            font-size: 24px;
            color: $primary;
            text-transform: uppercase;
        }

        p {
            font-size: 16px;
            line-height: 1.5;
        }
    }

    button.prev,
    button.next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.5);
        color: white;
        border: none;
        font-size: 32px;
        padding: 10px 15px;
        cursor: pointer;
        border-radius: 4px;
        transition: background 0.3s;

        &:hover:not(:disabled) {
            background: rgba(0, 0, 0, 0.7);
        }

        &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
    }

    button.prev {
        left: 10px;
    }

    button.next {
        right: 10px;
    }
}
</style>